/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_TitleInputs */

const en_planner_title = /** @type {(inputs: Planner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan my week`)
};

const de_planner_title = /** @type {(inputs: Planner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche planen lassen`)
};

/**
* | output |
* | --- |
* | "Plan my week" |
*
* @param {Planner_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_title = /** @type {((inputs?: Planner_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_title(inputs)
	return en_planner_title(inputs)
});